import { render } from "./LoginSection.vue?vue&type=template&id=4badfff0"
import script from "./LoginSection.vue?vue&type=script&lang=js"
export * from "./LoginSection.vue?vue&type=script&lang=js"

import "./LoginSection.vue?vue&type=style&index=0&id=4badfff0&lang=css"

import exportComponent from "/opt/1psim/portal_test/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__